import { EventEmitter } from 'events';

export default class BaseStore extends EventEmitter {
  emitChange(value?: unknown) {
    this.emit('changed', value);
  }

  addChangeListener(callback) {
    return this.on('changed', callback);
  }

  removeChangeListener(callback) {
    this.removeListener('changed', callback);
  }
}
